export enum ErrorPortability {
  request = 'internal_server_error',
  quoteNotChange = 'error_order_quote_value_cannot_be_changed'
}

export enum ModalSteps {
  info = 1,
  changeValue = 2,
  finishStep = 3
}
